export const getDxpUrl = () => {
    const { REACT_APP_DXP_SCHEME, REACT_APP_DXP_HOST, REACT_APP_DXP_PORT } = process.env;
    return `${REACT_APP_DXP_SCHEME}://${REACT_APP_DXP_HOST}:${REACT_APP_DXP_PORT}`;
};